import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  // const bringOptionsMapRef = useRef({})
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q4: '{q3} = 0',
    q5: '{q3} = 0',
    q6: '{q3} = 0',
    q7: '{q3} = 0',
    q8: '{q3} = 0',
    q9: '{q3} = 0',
    q10: '{q3} = 0',
    q11: '{q3} = 0',
    q12: '{q3} = 0',
    q13: '{q3} = 0',
    q14: '{q3} = 0',
    q15: '{q3} = 0',
    q16: '{q3} = 0',
    q17: '{q3} = 0',
    q18: '{q3} = 0',
    q19: '{q3} = 0',
    q20: '{q3} = 0',
    q21: '{q3} = 1',
    q22: '{q3} = 1',

    q76: '{q75} = 1 or {q75} = 2 or {q75} = 3 or {q75} = 4 ',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q1} = 1) or ({q2} = 0)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    // bringOptionsMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  // const endMessage = `很抱歉，目前與您相同特性的樣本已經額滿，沒辦法參與本次活動。歡迎您分享本問卷連結給其他親朋好友，或加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  // const endSurveyMsg = (survey) => {
  //   if (survey.getValue('q1') === 1 || survey.getValue('q2') === 0) {
  //     setCompletionMessage(endMessage)
  //   } else {
  //     setCompletionMessage(
  //       `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`
  //     )
  //   }
  // }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    // endSurveyMsg,
    // bringOptionsMapRef,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
